module.exports = __webpack_public_path__ + "static/media/calendar-alt.ad2925bf.svg";